var _circle, _rect, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCityFilterIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 24,
    cy: 24,
    r: 24,
    fill: "#FEEDD8"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_10_2917",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 10,
    y: 10,
    width: 28,
    height: 28
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 10,
    y: 10,
    width: 28,
    height: 28,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_10_2917)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M25.6482 23.3147C26.1052 22.8578 26.3337 22.3085 26.3337 21.6668C26.3337 21.0252 26.1052 20.4759 25.6482 20.0189C25.1913 19.562 24.642 19.3335 24.0003 19.3335C23.3587 19.3335 22.8094 19.562 22.3524 20.0189C21.8955 20.4759 21.667 21.0252 21.667 21.6668C21.667 22.3085 21.8955 22.8578 22.3524 23.3147C22.8094 23.7717 23.3587 24.0002 24.0003 24.0002C24.642 24.0002 25.1913 23.7717 25.6482 23.3147ZM24.0003 32.5752C26.3725 30.3974 28.1323 28.4189 29.2795 26.6397C30.4267 24.8606 31.0003 23.2807 31.0003 21.9002C31.0003 19.7807 30.3246 18.0453 28.9732 16.6939C27.6219 15.3425 25.9642 14.6668 24.0003 14.6668C22.0364 14.6668 20.3788 15.3425 19.0274 16.6939C17.676 18.0453 17.0003 19.7807 17.0003 21.9002C17.0003 23.2807 17.5739 24.8606 18.7212 26.6397C19.8684 28.4189 21.6281 30.3974 24.0003 32.5752ZM24.0003 35.6668C20.8698 33.0029 18.5316 30.5286 16.9857 28.2439C15.4399 25.9592 14.667 23.8446 14.667 21.9002C14.667 18.9835 15.6052 16.6599 17.4816 14.9293C19.358 13.1988 21.5309 12.3335 24.0003 12.3335C26.4698 12.3335 28.6427 13.1988 30.5191 14.9293C32.3955 16.6599 33.3337 18.9835 33.3337 21.9002C33.3337 23.8446 32.5607 25.9592 31.0149 28.2439C29.4691 30.5286 27.1309 33.0029 24.0003 35.6668Z",
    fill: "#EAA245"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCityFilterIcon);
export default __webpack_public_path__ + "static/media/CityFilterIcon.4d150457dbf5334b71410eaeccb4202f.svg";
export { ForwardRef as ReactComponent };